<template>
  <v-footer class='index-footer'>
    <v-layout justify-center row wrap class='social-icons'>
      <a flat class='facebook-logo' v-if="$t('social.facebook')" :href="$t('social.facebook')" />
      <a flat class='instagram-logo' v-if="$t('social.instagram')" :href="$t('social.instagram')" />
    </v-layout>

    <v-layout justify-center row wrap>
      <v-btn
        flat
        round
        color='white'
        class='mt-0'
        :to="{name: 'Faq', params: {lang: $route.params.lang}}"
      >
        <span class='show-mobile'>FAQ</span>
        <span class='hide-mobile'>{{ $t('profile.faq') }}</span>
      </v-btn>
      <v-btn
        flat
        round
        color='white'
        class='mt-0'
        :to="{name: 'Termos', params: {lang: $route.params.lang}}"
      >{{ $t('text.termsOfUse') }}
      </v-btn>
      <v-btn
        flat
        round
        color='white'
        class='mt-0 mr-5'
        :to="{name: 'Politica', params: {lang: $route.params.lang}}"
      >{{ $t('text.privacyPolicy') }}
      </v-btn>
      <LanguageSwitcher dark />
    </v-layout>
  </v-footer>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher';

export default {
  name: 'loading',
  components: {
    LanguageSwitcher
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {}
};
</script>

<style lang='scss' scoped>
html {
  height: 100%;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.social-icons {
  margin: 20px 0 10px 0;
}

.instagram-logo {
  background-image: url("../assets/img/instagram-logo.svg");
  height: 30px !important;
  width: 30px !important;
  background-size: contain;
  margin-left: 20px;
  display: block;
  z-index: 999;
}

.facebook-logo {
  background-image: url("../assets/img/facebook-logo.svg");
  height: 30px !important;
  width: 30px !important;
  background-size: contain;
  display: block;
  z-index: 999;
}

.index-footer {
  width: 100%;
  display: block;
  height: auto !important;
  position: relative;

  &:before {
    content: "";
    left: 0;
    right: 0;
    bottom: 0;
    height: 80px;
    position: absolute;
    //background: -moz-linear-gradient(
    //    top,
    //    rgba(7, 11, 70, 0) 0%,
    //    rgba(7, 11, 70, 0) 1%,
    //    rgba(7, 11, 70, 1) 40%,
    //    rgba(7, 11, 70, 1) 100%
    //);
    //background: -webkit-linear-gradient(
    //    top,
    //    rgba(7, 11, 70, 0) 0%,
    //    rgba(7, 11, 70, 0) 1%,
    //    rgba(7, 11, 70, 1) 40%,
    //    rgba(7, 11, 70, 1) 100%
    //);
    //background: linear-gradient(
    //    to bottom,
    //    rgba(7, 11, 70, 0) 0%,
    //    rgba(7, 11, 70, 0) 1%,
    //    rgba(7, 11, 70, 1) 40%,
    //    rgba(7, 11, 70, 1) 100%
    //);
    //filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00070b46', endColorstr='#070b46', GradientType=0);
  }

  &.v-footer {
    background: none;

    span {
      position: relative;
    }

    .v-btn {
      font-size: 16px;
      font-weight: lighter;

      &.v-btn--active {
        opacity: 0.3;
      }

      &:before {
        background: none !important;
      }
    }
  }

  .show-mobile {
    display: none;
  }

  @media only screen and (max-width: 439px) {
    .v-btn {
      padding: 0 10px;
      width: 220px;
      margin: 0 auto !important;
    }

    .show-mobile {
      display: block;
    }

    .hide-mobile {
      display: none;
    }
  }
}
</style>
